import api from "@/api/api-v2-config";

export async function getIncomeListAxios(id) {
  return await api.get("incomes/income?BankId=" + id);
}

export async function postIncomeListAxios(data) {
  return await api.post("incomes/income", data);
}

export async function updateIncomeListAxios(data) {
  return await api.put("incomes", data);
}

export async function deleteIncomeListAxios(id) {
  return await api.delete("incomes/" + id);
}